<div class="modal-overlay" id="otpModal" >
    <div class="otp-modal">
        <div *ngIf="loading" class="loading">
            <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
        </div>
        <div class="modal-head">
            <div class="title">
                <div *ngIf="viewFLag === 'scan'">{{'otp-modal.scan.title' | translate}}</div>
                <div *ngIf="viewFLag === 'verify'">{{'otp-modal.verify.title' | translate}}</div>
            </div>
            <div class="close" (click)="cancelOtpVerfication()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
        </div>
        <div class="modal-body">
            <div *ngIf="viewFLag === 'scan'" class="scan-wrapper otp-wrapper">
                <div class="title">
                    {{'otp-modal.scan.sub-title' | translate}}
                </div>
                <div class="mail-wrapper">
                    <div class="mail-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none">
                            <circle cx="20.5" cy="20.7532" r="20" fill="#F7F8FA" />
                            <path
                                d="M28.125 16.6907V24.5657C28.125 25.0132 27.9472 25.4424 27.6307 25.7589C27.3143 26.0754 26.8851 26.2532 26.4375 26.2532H15.1875C14.7399 26.2532 14.3107 26.0754 13.9943 25.7589C13.6778 25.4424 13.5 25.0132 13.5 24.5657V16.6907M28.125 16.6907C28.125 16.2431 27.9472 15.8139 27.6307 15.4974C27.3143 15.181 26.8851 15.0032 26.4375 15.0032H15.1875C14.7399 15.0032 14.3107 15.181 13.9943 15.4974C13.6778 15.8139 13.5 16.2431 13.5 16.6907M28.125 16.6907V16.8729C28.125 17.161 28.0513 17.4444 27.9108 17.6959C27.7703 17.9474 27.5678 18.1588 27.3225 18.3099L21.6975 21.7712C21.4314 21.9351 21.125 22.0219 20.8125 22.0219C20.5 22.0219 20.1936 21.9351 19.9275 21.7712L14.3025 18.3107C14.0572 18.1596 13.8547 17.9482 13.7142 17.6966C13.5737 17.4451 13.5 17.1618 13.5 16.8737V16.6907"
                                stroke="#0074EC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="mail-content">
                        <div class="mail-title">
                            {{'otp-modal.scan.mail-title' | translate}}
                        </div>
                        <div class="mail">
                            {{email}}
                        </div>
                    </div>
                </div>
                <div class="send-code-wrapper">
                    <button (click)="sendOtp()" class="btn otp-btn">
                        {{'otp-modal.scan.btn' | translate}}
                    </button>
                </div>
                <!-- Contact support via Freshchat-widget-->
                <div class="contact-support-wrapper">
                    <div class="title">
                        {{'otp-modal.scan.contact-title' | translate}}
                    </div>
                    <div class="action" (click)="openContactSupportDialog()">
                        {{'otp-modal.scan.contact-action' | translate}}
                    </div>
                </div>
            </div>

            <div *ngIf="viewFLag === 'verify'" class="verify-wrapper otp-wrapper">
                <div class="sub-title">
                    {{'otp-modal.verify.sub-title' | translate}}
                </div>
                <div class="send-via">
                    <div class="email">
                        {{email}}
                    </div>

                    <!-- <div class="suffix" *ngIf="lang == 'en'">
                        {{'otp-modal.verify.via-mail' | translate}}
                    </div> -->
                </div>
                <div class="otp-with-err-container">
                    <div  class="otp-input-container" [ngClass]="{'otp-shake': shakeOtp}">
                        <app-otp-input [length]="6" (otpComplete)="onOtpEntered($event)" [errorState]="showError"></app-otp-input>
                    </div>
                    <div class="otp-error" *ngIf="showError">
                        {{errorMsg}}
                    </div>
                </div>

                <button (click)="verfiyOtp()" class="btn otp-btn"  [ngClass]="{'verfiy-btn-disabled': !isOtpEntered}">
                    {{'otp-modal.verify.verify-btn' | translate}}
                </button>

                <div class="resend-wrapper">
                    <div class="title">
                        {{'otp-modal.verify.resend-title' | translate}}
                    </div>
                    <div class="action" *ngIf="!pauseResending" (click)="resendOtp()">
                        {{'otp-modal.verify.resend-action' | translate}}
                    </div>
                    <div *ngIf="pauseResending" class="timer">
                        {{formattedTime}}
                    </div>
                </div>
            </div>
        </div>
        <!-- <p *ngIf="latestCashedSecuredApiData">Received Data: {{ latestCashedSecuredApiData | json }}</p> -->

        <div *ngIf="showContactSupportDialog" class="contact-support-dialog">
            <div class="contact-dialog-card">
                <div class="contact-dialog-head">
                    <div class="contact-dialog-title">
                        {{'otp-modal.scan.contact-dialog.title' | translate}}
                    </div>
                    <div class="close" (click)="closeContactSupportDialog()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#667085" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <div class="contact-dialog-body">
                    <div class="contact-dialog-desc">
                        {{'otp-modal.scan.contact-dialog.desc' | translate}}
                    </div>
                    <div class="email-row">
                        <span class="email-value">{{supportEmail}}</span>
                        <button class="copy-btn" (click)="copySupportEmail()">
                            <span *ngIf="!emailCopied">{{'otp-modal.scan.contact-dialog.copy' | translate}}</span>
                            <span *ngIf="emailCopied">{{'otp-modal.scan.contact-dialog.copied' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>